export default "Phone number is in an unrecognized format. Try one of: <br />\r\n<br />(111) 222-3333 <br />\r\n<br />111-222-3333 <br />\r\n<br />1112223333";